import {datadogLogs} from '@datadog/browser-logs';
import {datadogRum} from '@datadog/browser-rum';
import {resolveDatadogConfig} from '@local/logics/datadog/config';

let started = false;

// CefSharp(Outlook SafeSearch 等のセキュリティボット)が生成するエラー
// ref. https://github.com/DataDog/browser-sdk/issues/2715
export const isCefSharpError = (message: string | undefined): boolean =>
  message !== undefined && message.includes('Object Not Found Matching Id:');

export const isAbortError = (errorKind: string | undefined): boolean => errorKind === 'AbortError';

/**
 * Datadog RUM / Logs を初期化する。
 *
 * - ブラウザでのみ動く。SSR 中は何もしない
 * - 環境変数が揃っていない、または NEXT_PUBLIC_DATADOG_ENABLED が 'true' でない場合は何もしない
 * - 二重には初期化しない
 */
export const startMonitoring = () => {
  if (typeof window === 'undefined' || started) {
    return;
  }

  const config = resolveDatadogConfig();
  if (!config) {
    console.warn('[datadog] 設定が無効なため監視を開始しません');
    return;
  }

  datadogRum.init({
    applicationId: config.applicationId,
    clientToken: config.clientToken,
    site: config.site,
    service: config.service,
    env: config.env,
    version: config.version,
    sessionSampleRate: 100,
    sessionReplaySampleRate: config.isRelaxedPrivacyEnv ? 100 : 20,
    defaultPrivacyLevel: config.isRelaxedPrivacyEnv ? 'allow' : 'mask',
    traceSampleRate: 20,
    trackResources: true,
    trackLongTasks: true,
    trackUserInteractions: true,
    storeContextsAcrossPages: true,
    beforeSend: event => {
      if (event.type === 'error' && isCefSharpError(event.error?.message)) {
        return false;
      }
      return true;
    },
  });
  datadogRum.startSessionReplayRecording();

  datadogLogs.init({
    clientToken: config.clientToken,
    site: config.site,
    service: config.service,
    env: config.env,
    version: config.version,
    sessionSampleRate: 100,
    forwardErrorsToLogs: true,
    storeContextsAcrossPages: true,
    beforeSend: log => {
      if (log.http && [0, 401, 404].includes(log.http.status_code)) {
        return false;
      }
      if (log.status === 'error' && isCefSharpError(log.message)) {
        log.status = 'warn' as const;
      }
      if (log.status === 'error' && isAbortError(log.error?.kind)) {
        log.status = 'warn' as const;
      }
      return true;
    },
  });

  started = true;
};
